export enum ReportStatus {
    Review = 1,
    Final = 2,
    VoidedReview = 3,
    VoidedFinal = 4
}

export const ReportStatusObjects = {
    ReviewStatus: { id: 1, name: "Review" },
    FinalStatus: { id: 2, name: "Final" },
    VoidReviewStatus: { id: 3, name: "Voided Review" },
    VoidFinalStatus: { id: 4, name: "Voided Final" }
}

export const ReportStatusArray = [
    ReportStatusObjects.ReviewStatus,
    ReportStatusObjects.FinalStatus,
    ReportStatusObjects.VoidReviewStatus,
    ReportStatusObjects.VoidFinalStatus
]